import * as main from './main';
import { updateAxisType, updateQueryString, highlightSeason, highlightSelectedRegionInRegionalChart } from '../utils';
import { showRegion, showStation } from '../components/charts/map';
import { makePopup } from '../components/popup';

import { plotTimeSeriesMultiModel, addTrendMultiModel, cleanTrendMultiModel } from '../components/charts/time-series-multi-model';

/*import interfaces and extend window variable*/
import { Aeroval } from '../types/global';
declare var aeroval: Aeroval;

document.addEventListener('DOMContentLoaded', () => {
	if (window.location.pathname.includes('pages/intercomp')) init();
});

function init(): void {
	console.log('initialize intercomparison page');
	// set some defaults
	aeroval.goto = false;
	aeroval.tsType = 'regular'; //diurnal cycle
	aeroval.seriesVisibility = {};
	aeroval.menuButtons = ['parameter', 'observation', 'time', 'interModelStatistic', 'statistic'];
	aeroval.axisType = 'linear';

	main.getQueryStrings();
	main.getExperiments();
	main.updateURLs('project', aeroval.project);

	// scattering axis toggle
	const scatAxisToggle = document.getElementById('scat-axis-toggle') as HTMLInputElement;
	if (!scatAxisToggle) return
	scatAxisToggle.addEventListener('change', function () {
		aeroval.axisType = this.checked ? 'logarithmic' : 'linear'
		updateAxisType();
	});

	// add info popup until May 15th, 2026
	if (new Date() < new Date('2026-05-15')) {
		makePopup('info-intercomp', 'Looking for all <strong>individual models</strong> in the time series and regional plots?<br>Select <em>Show Individual Models</em> in your settings ⚙️', 'warning', true, 10000);
	}
}

export function callbackGlobStat(update_ts = true, update_scat = true) {
	document.querySelector('#map')?.classList.remove('loading');
	const initLoader = document.getElementById('init-loader');
	if (initLoader) initLoader.style.display = 'none';
	main.ts(update_ts, update_scat);
}

export function callbackMenu(reg_stat = true, update_ts = true, update_scat = true) {
	main.map(reg_stat, update_ts, update_scat);
}

export function update(which: string, what: any, wait: boolean = false): void {
	console.info('update ', which, 'with ', what);
	if (which == 'station' && what) {
		//for MODIS, station are tuples, and seen hre as array
		aeroval.station = typeof what != 'string' ? `(${what[0].toFixed(1)}, ${what[1].toFixed(1)})` : what;
		showStation(aeroval.station);
		highlightSelectedRegionInRegionalChart('reg-stat', '');
		if (aeroval.tsType == 'regular') {
			main.ts();
		} else {
			main.tsWeekly();
		}
		updateQueryString(which, what);
		main.updateURLs(which, what);
		updateQueryString('region', '');
		main.updateURLs('region', '');
	}
	if (which == 'region' && what) {
		//for MODIS, station are tuples, and seen hre as array
		aeroval.region = what;
		aeroval.station = what;
		showStation('');
		showRegion(what, aeroval.settings.zoomOnSelectedRegion === 'true');
		highlightSelectedRegionInRegionalChart('reg-stat', what);
		if (aeroval.tsType == 'regular') {
			main.ts();
		} else {
			main.tsWeekly();
		}
		updateQueryString(which, what);
		main.updateURLs(which, what);
		updateQueryString('station', '');
		main.updateURLs('station', '');
	}
	if (which == 'parameter') {
		delete aeroval.chartOptions;
		aeroval.parameter.dir = what;
		main.topMenu();
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'experiment') {
		delete aeroval.chartOptions;
		aeroval.experiment = aeroval.experiments[what];
		aeroval.experiment.name = what;
		main.getExpSettings();
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'model') {
		aeroval.model.dir = what;
		//get modVar
		aeroval.model.var = aeroval.modVars[what];
		main.map(true, true);
		main.showMenu(which, what, what);
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'observation') {
		aeroval.observation = what;
		main.map(true, true);
		main.showMenu(which, what, what);
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'statistic') {
		delete aeroval.chartOptions;
		aeroval.statistic = aeroval.statistics[what];
		aeroval.statistic.dir = what;
		main.map(true, false, false);
		if (!aeroval.statistic.dir.includes('trend')) {
			cleanTrendMultiModel('intercomp-ts');
		} else if (aeroval.data.ts) {
			plotTimeSeriesMultiModel(aeroval.data.ts, 'intercomp-ts', true);
		}
		main.showMenu(which, aeroval.statistic.name);
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'layer') {
		updateQueryString('layer', what);
		if (!wait) {
			main.map(true, true);
			main.profile();
			main.showMenu(which, what);
		}
		updateQueryString(which, what);
	}
	if (which == 'frequency') {
		aeroval.frequency = what;
		main.checkSeasonMenu();
		main.topMenu();
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'time') {
		aeroval.time = what;
		delete aeroval.dateMin;
		delete aeroval.dateMax;
		updateQueryString('time', what);
		main.map(true, false, false);
		main.showMenu(which, what);
		main.getExtremeDates(false, false);
		if (aeroval.data.ts) {
			plotTimeSeriesMultiModel(aeroval.data.ts, 'intercomp-ts', true);
		}
		main.updateURLs(which, what);
	}
	if (which == 'interModelStatistic') {
		delete aeroval.chartOptions;
		aeroval.interModelStatistic = aeroval.interModelStatistics[what];
		aeroval.interModelStatistic.dir = what;
		main.map(true, true, true);
		main.showMenu(which, aeroval.interModelStatistic.name);
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'season') {
		aeroval.season = what;
		main.map(true, false, true);
		main.getExtremeDates(false, false);
		highlightSeason('intercomp-ts');
		if (aeroval.statistic.dir.includes('trend')) {
			addTrendMultiModel('intercomp-ts');
		}
		main.showMenu('time', aeroval.time);
		main.updateURLs(which, what);
	}
}
